export default __webpack_public_path__ + "static/media/vessels_closed_sales_vessel.0cbd7a30.svg";